import { FormStore, GlobalStore, GridStore, UserStore } from '@roc/feature-app-core';
import { GENERIC_ERROR_MESSAGE } from '@roc/feature-utils';
import { computed, flow, makeObservable, observable, action } from 'mobx';
import { CadenceService } from '../../services/cadenceServices/cadenceService';
import { FieldDefinition } from 'libs/feature-backoffice-users/src/backOfficeUsers/stores/editLeadsDashboardStore';
import { ApiResponse } from '@roc/feature-app-core';
import { CadenceTemplateGrid } from '@roc/feature-types';
import { ProspectsByOriginatorGridStore } from './prospectsByOriginatorGridStore';
import { ProspectsByOriginatorGridStoreV2 } from './prospectsByOriginatorGridStoreV2';
import { DialSessionStore } from 'libs/feature-backoffice-users/src/backOfficeUsers/stores/dialSessionStore';

const REQUIRED_MESSAGE = 'This field is required';

const cadenceFormFields = {
  fields: {
    cadenceName: {
      value: '',
      error: null,
      rule: '',
    },
    subject: {
      value: '',
      error: null,
      rule: '',
    },
    content: {
      value: '',
      error: null,
      rule: '',
    },
    stepContent: {
      value: '',
      error: null,
      rule: '',
    },
    type: {
      value: '',
      error: null,
      rule: '',
    },
    day: {
      value: '',
      error: null,
      rule: 'required',
    },
    title: {
      value: '',
      error: null,
      rule: 'required',
    },
    stepNumber: {
      value: '',
      error: null,
      rule: '',
    },
    emailTemplateId: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class CadenceStore {
  private globalStore: GlobalStore;
  private userStore: UserStore;
  private cadenceService: CadenceService;
  public searchText: string;

  // leadsDashboardGridStore: LeadsDashboardGridStore;
  // editLeadsDashboardStore: EditLeadsDashboardStore;
  public cadenceUsersDashboardGridStore: GridStore;
  public cadenceUsersDashboardGridStoreV2: GridStore;
  public cadenceProspectsByOriginatorGridStore: ProspectsByOriginatorGridStore;
  public cadenceProspectsByOriginatorGridStoreV2: ProspectsByOriginatorGridStoreV2;


  selectedLeadList: any = [];
  public stepError: string;
  public standartList: Boolean;
  activeStep: number;
  dashboards: any = [];
  columns: FieldDefinition[] = [];
  standardDashboards: any = [];
  allDashboards: any = [];
  dashboardActions: any;
  currentDashboardId: any = {};
  cadence: any;
  cadences: any[];
  templatesRows: CadenceTemplateGrid[] = [];
  allPeople: any = [];
  cadenceSelectedUsers: any = [];
  backOfficeAssociated: any[];
  cadenceStepDueResponse: any;
  loadingLeads: boolean;
  isAddingMoreProspectsActive: boolean = false;
  cadenceForm: FormStore;
  cadenceTemplatesGridStore: GridStore;
  callingFromMyCadences: boolean;
  public gridBusinessUnit: string = 'FACO';
  selectedProspectId: any = null;
  cadenceOptions: any = [];
  currentCadenceId: any;
  addCadenceContactsSuccessfuly = false;
  dialSession: DialSessionStore;
  selectedOriginator: any = -1;
  owners: any[];
  creatingTemplate = false;
  templateAtt = []

  constructor(
    globalStore: GlobalStore,
  ) {
    this.globalStore = globalStore;
    this.cadenceService = new CadenceService();
    this.cadenceForm = new FormStore(cadenceFormFields, globalStore);
    this.cadenceTemplatesGridStore = new GridStore(() =>
      this.fetchCadenceTemplates()
    );
    this.cadenceUsersDashboardGridStore = new GridStore(() => this.fetchRows(), null, 50)
    this.cadenceUsersDashboardGridStoreV2 = new GridStore(() => this.fetchRowsV2(), null, 50)
    this.cadenceProspectsByOriginatorGridStore = new ProspectsByOriginatorGridStore(
      globalStore,
      this
    );
    this.cadenceProspectsByOriginatorGridStoreV2 = new ProspectsByOriginatorGridStoreV2(globalStore, this)
    this.templatesRows = [];
    this.cadence = {};
    this.currentDashboardId = {};
    this.callingFromMyCadences = false;
    this.dialSession = new DialSessionStore();

    this.setDefaults();
    makeObservable(this, {
      resetSelectedLeadList: action,
      removeIdFromSelectedLeadList: action,
      addIdToSelectedLeadList: action,
      selectedLeadList: observable,
      standartList: observable,
      selectedProspectId: observable,
      setSelectedProspectId: action,
      setStandartList: action,
      stepError: observable,
      activeStep: observable,
      addCadence: action,
      addTemplate: action,
      allDashboards: observable,
      allPeople: observable,
      assignUsersToCadence: flow,
      backOfficeAssociated: observable,
      cadence: observable,
      cadenceSelectedUsers: observable,
      isAddingMoreProspectsActive: observable,
      loadingLeads: observable,
      gridBusinessUnit: observable,
      cadences: observable,
      copyCadence: flow,
      createCadence: flow,
      createStep: flow,
      editStep: flow,
      currentDashboardId: observable,
      dashboardActions: observable,
      cadenceStepDueResponse: observable,
      fetchOriginatorsAssociatedWithCadence: flow,
      completeCallStepForCadenceContacts: flow,
      markCadenceContactAsUnsubscribed: flow,
      fetchCadenceContentDataByCadenceId: flow,
      fetchDashboards: flow,
      fetchCadencesDueByBackofficeOriginator: flow,
      saveListViewId: flow,
      resetStore: flow,
      searchText: observable,
      settingCadenceAssignedUsers: action,
      settingDashboardId: action,
      templatesRows: observable,
      updateCadenceName: flow,
      callingFromMyCadences: observable,
      setCallingFromMyCadences: action,
      setIsAddingMoreProspectsActive: action,
      addNewProspects: flow,
      pauseCadence: flow,
      resumeCadence: flow,
      getCadenceOptions: flow,
      cadenceOptions: observable,
      currentCadenceId: observable,
      setCadenceOption: action,
      addCadenceContacts: flow,
      removeProspectFromPartialList: flow,
      addCadenceContactsSuccessfuly: observable,
      completeCallStepForCadenceContact: flow,
      selectedOriginator: observable,
      setSelectedOriginator: action,
      owners: observable,
      getOwners: flow,
      resetOwners: action,
      fetchCadenceContentDataByCadenceIdAndUserId: flow,
      fetchCadenceContentDataWithProspectsByCadenceId: flow,
      deleteCadence: flow,
      fetchCadencesDueByBackofficeOriginatorAndCadenceId: flow,
      creatingTemplate: observable,
      templateAtt: observable,
    });
  }

  setDefaults() {
    this.activeStep = 0;
    this.searchText = '';
    this.isAddingMoreProspectsActive = false;
    this.cadenceForm.onFieldChange('subject', '');
    this.cadenceForm.onFieldChange('content', '');
    this.cadenceForm.onFieldChange('stepContent', '');
    this.cadenceForm.onFieldChange('type', '');
    this.cadenceForm.onFieldChange('day', '');
    this.cadenceForm.onFieldChange('title', '');
  }

  setIsAddingMoreProspectsActive(value) {
    this.isAddingMoreProspectsActive = value;
  }

  settingDashboardId(option) {
    this.currentDashboardId = option;
  }

  settingCadenceStepDueResponse(dueResponse) {
    this.cadenceStepDueResponse = dueResponse;
  }

  settingCadenceAssignedUsers(usersIds) {
    this.cadenceSelectedUsers = usersIds;
  }

  addCadence(newCadence) {
    this.cadences.push(newCadence);
  }

  *removeProspectFromPartialList() {
    try {
      yield this.cadenceService.removeProspect(this.selectedProspectId, this.cadence?.cadenceId, this.gridBusinessUnit)
      this.cadenceUsersDashboardGridStoreV2.fetchGridData()
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  addTemplate(newTemplate) {
    this.templatesRows.push(newTemplate);
  }

  setCallingFromMyCadences(callingFromMyCadences: boolean) {
    this.callingFromMyCadences = callingFromMyCadences
  }

  *resetStore() {
    this.cadenceForm.reset();
    this.setDefaults();
  }

  async fetchCadenceTemplates() {
    try {
      const response: ApiResponse = await this.cadenceService.getCadenceTemplatesByUser(
        this.cadenceTemplatesGridStore.gridData.meta.pageNumber,
        this.cadenceTemplatesGridStore.gridData.meta.pageSize,
        this.cadenceTemplatesGridStore.gridData.meta.sortDir,
        this.cadenceTemplatesGridStore.gridData.meta.sortBy,
        this.cadenceTemplatesGridStore.gridData.meta.filters,
        this.cadenceTemplatesGridStore.gridData.meta.dropdownFilters,
        this.isMyCadenceURL() ? true : false
      );
      this.templatesRows = response.data.data.rows;

      return response;
    } catch (error) {
      console.log('error ', error)
    }
  }

  private isMyCadenceURL() {
    const pathParts = location.pathname.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    return lastPart === 'cadence';
  };

  *fetchCadenceContentDataByCadenceId(cadenceId: number) {
    try {
      const response = yield this.cadenceService.getDataContentByCadenceId(cadenceId, this.callingFromMyCadences);
      this.cadence = response.data.data;
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *fetchCadenceContentDataWithProspectsByCadenceId(cadenceId: number) {
    try {
      const response = yield this.cadenceService.getDataContentWithProspectsByCadenceId(cadenceId, this.callingFromMyCadences);
      this.cadence = response.data.data;
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *fetchCadenceContentDataByCadenceIdAndUserId(cadenceId: number) {
    try {
      const response = yield this.cadenceService.getDataContentByCadenceIdAndUserId(cadenceId, this.selectedOriginator);
      this.cadence = response.data.data;
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }


  *createCadence(cadenceName: string) {
    try {
      const cadenceInfo = {
        cadenceName: cadenceName
      }

      const response = yield this.cadenceService.createCadence(cadenceInfo);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence has been created successfully',
        });
        this.cadenceTemplatesGridStore.resetAndFetchGridData()
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while creating the cadence',
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  *copyCadence(cadenceId: number) {
    try {

      const cadenceInfo = {
        cadenceId: cadenceId
      }

      const response = yield this.cadenceService.copyCadence(cadenceInfo);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence has been copied successfully',
        });
        this.cadenceTemplatesGridStore.resetAndFetchGridData()
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while copying the cadence',
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  *updateCadenceName(cadenceId: number, newName: String) {
    try {

      const cadenceInfo = {
        cadenceId: cadenceId,
        newName: newName
      }

      const response = yield this.cadenceService.updateCadenceName(cadenceInfo);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence name has been updated successfully',
        });
        this.fetchCadenceContentDataByCadenceId(cadenceId);
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while changing cadence name',
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  *saveListViewId(currentDashboardId, partialList) {
    try {
      if (!this.checkStepErrors()) {
        if (partialList) {
          currentDashboardId["partialList"] = partialList;
          currentDashboardId["selectedLeadsInList"] = this.selectedLeadList;
        } else {
          currentDashboardId["partialList"] = partialList;
          currentDashboardId["selectedLeadsInList"] = [];
        }
        yield this.cadenceService.saveListViewId(this.cadence?.cadenceId, currentDashboardId);
        this.fetchCadenceContentDataByCadenceId(this.cadence?.cadenceId);
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while saving the list id',
      });
    }
  }

  *fetchDashboards() {
    try {
      const response = yield this.cadenceService.getCustomDashboards();
      this.dashboards = JSON.parse(
        response.data.data.customDashboards
      ).dashboards;
      this.standardDashboards = response.data.data.standardDashboards;
      this.allDashboards = [...this.standardDashboards, ...this.dashboards];
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *fetchCadencesDueByBackofficeOriginator() {
    try {
      const response = yield this.cadenceService.getCadenceStepDueForBackOfficeUser();
      this.settingCadenceStepDueResponse(response?.data?.data)
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *fetchCadencesDueByBackofficeOriginatorAndCadenceId() {
    try {
      const response = yield this.cadenceService.getCadenceStepDueForBackOfficeUserAndCadenceId(this.cadence?.cadenceId);
      this.settingCadenceStepDueResponse(response?.data.data)
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *createStep() {
    try {
      const cadenceId = this.cadence?.cadenceId
      const newStep = {
        stepNumber: this.cadenceForm.form.fields.stepNumber.value,
        day: this.cadenceForm.form.fields.day.value,
        title: this.cadenceForm.form.fields.title.value,
        type: this.cadenceForm.form.fields.type.value,
        stepContent: {
          subject: this.cadenceForm.form.fields.subject.value,
          content: this.cadenceForm.form.fields.content.value,
          emailTemplateId: this.cadenceForm.form.fields.emailTemplateId.value,
          selectedBusinessUnit: this.gridBusinessUnit
        }
      }
      const response = yield this.cadenceService.createCadenceStep(newStep, cadenceId);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence Step has been saved successfully',
        });
        this.resetStore();
        this.fetchCadenceContentDataByCadenceId(cadenceId);
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while saving the cadence Step',
        });
        this.resetStore();
        this.fetchCadenceContentDataByCadenceId(cadenceId);
      }

    } catch (error) {
      console.log(error);
    }
  }

  *editStep() {
    try {
      const cadenceId = this.cadence?.cadenceId
      const newStep = {
        stepNumber: this.cadenceForm.form.fields.stepNumber.value,
        day: this.cadenceForm.form.fields.day.value,
        title: this.cadenceForm.form.fields.title.value,
        type: this.cadenceForm.form.fields.type.value,
        stepContent: {
          subject: this.cadenceForm.form.fields.subject.value,
          content: this.cadenceForm.form.fields.content.value,
          emailTemplateId: this.cadenceForm.form.fields.emailTemplateId.value,
          selectedBusinessUnit: this.gridBusinessUnit
        }
      }
      const response = yield this.cadenceService.editCadenceStep(newStep, cadenceId);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence Step has been saved successfully',
        });
        this.resetStore();
        this.fetchCadenceContentDataByCadenceId(cadenceId);
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while saving the cadence Step',
        });
        this.resetStore();
        this.fetchCadenceContentDataByCadenceId(cadenceId);
      }

    } catch (error) {
      console.log(error);
    }
  }

  *assignUsersToCadence(cadenceId: Number) {
    try {

      const payload = {
        cadenceId: cadenceId,
        usersId: this.cadenceSelectedUsers.map(user => user.userId),
      };

      const response = yield this.cadenceService.assignUsersToCadences(payload);

      if (response.data?.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Cadence users assigned successfully',
        });
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while assigning users to the cadence',
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  *fetchOriginatorsAssociatedWithCadence(cadenceId: Number) {
    try {
      const response = yield this.cadenceService.getOriginatorsAssociatedWithCadence(cadenceId);

      if (response.data?.status === 'OK') {
        this.backOfficeAssociated = response?.data?.data;
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while fetching users associated with cadence',
        });
      }
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *completeCallStepForCadenceContacts(cadenceContactsIds: any) {
    try {
      yield this.cadenceService.completeCallStepForCadenceContacts(cadenceContactsIds);
      this.fetchCadencesDueByBackofficeOriginatorAndCadenceId()
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Cadence Contacts where moved to the next step successfully',
      });
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *completeCallStepForCadenceContact(cadenceContactsId: any) {
    try {
      yield this.cadenceService.completeCallStepForCadenceContacts([cadenceContactsId]);
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *markCadenceContactAsUnsubscribed(cadenceContactsIds: any, reason: any) {
    try {
      yield this.cadenceService.markCadenceContactAsUnsubscribed(cadenceContactsIds, reason);
      this.fetchCadencesDueByBackofficeOriginatorAndCadenceId()
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Cadence Contacts where moved to the next step successfully',
      });
    } catch (e) {
      console.log(e)
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }


  setStandartList(value) {
    this.standartList = value;
  };

  setActiveStep = step => {
    this.activeStep = step;
  };

  goPrevStep = () => {
    this.activeStep--;
  };

  goNextStep = () => {
    this.stepError = '';
    if (!this.checkStepErrors()) {
      this.activeStep++;
    }
    if (this.stepError) {
      this.globalStore.notificationStore.showErrorNotification({
        message: this.stepError,
      });
    }
  };

  private checkStepErrors = () => {
    this.stepError = '';

    switch (this.activeStep) {
      case 0: {
        if (!this.currentDashboardId) {
          this.stepError = 'Please Select a Lead List';
          return true;
        }
        if (!this.gridBusinessUnit) {
          this.stepError = 'Please Select a Business Unit';
          return true;
        }
        break;
      }
      default:
        break;
    }

    return false;
  };

  fetchRowsV2 = async () => {
    try {
      return await this.cadenceService.getProspects(
        this.cadence?.cadenceId,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.pageNumber,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.pageSize,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.sortBy,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.sortDir,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.filters,
        this.cadenceUsersDashboardGridStoreV2.gridData.meta.dropdownFilters,
        this.selectedOriginator > 0 ? this.selectedOriginator : undefined,
      )
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

  fetchRows = async () => {
    try {
      if (!this.standartList) {
        return await this.fetchCustomDashboard();
      } else {
        return await this.fetchStandardDashboard()
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

  fetchStandardDashboard = async () => {
    const response: ApiResponse = await this.cadenceService.getLeadsListById(
      this.currentDashboardId?.value,
      this.cadence?.cadenceId,
      this.cadenceUsersDashboardGridStore.gridData.meta.pageNumber,
      this.cadenceUsersDashboardGridStore.gridData.meta.pageSize,
      this.cadenceUsersDashboardGridStore.gridData.meta.sortBy,
      this.cadenceUsersDashboardGridStore.gridData.meta.sortDir,
      this.cadenceUsersDashboardGridStore.gridData.meta.filters,
      this.cadenceUsersDashboardGridStore.gridData.meta.dropdownFilters,
      this.gridBusinessUnit,
      this.isAddingMoreProspectsActive
    );
    return response;
  }


  fetchCustomDashboard = async () => {
    const response = await this.cadenceService.getCustomLeadsListById(
      this.currentDashboardId?.value,
      this.cadence?.cadenceId,
      this.cadenceUsersDashboardGridStore.gridData.meta.pageNumber,
      this.cadenceUsersDashboardGridStore.gridData.meta.pageSize,
      this.cadenceUsersDashboardGridStore.gridData.meta.sortBy,
      this.cadenceUsersDashboardGridStore.gridData.meta.sortDir,
      this.cadenceUsersDashboardGridStore.gridData.meta.filters,
      this.cadenceUsersDashboardGridStore.gridData.meta.dropdownFilters,
      this.gridBusinessUnit,
      this.isAddingMoreProspectsActive
    );
    return response;
  }

  removeIdFromSelectedLeadList(id) {
    const index = this.selectedLeadList.indexOf(id);
    if (index > -1) {
      this.selectedLeadList.splice(index, 1);
    }
  }

  addIdToSelectedLeadList(id) {
    if (!this.selectedLeadList.includes(id)) {
      this.selectedLeadList.push(id);
    }
  }

  resetSelectedLeadList() {
    this.selectedLeadList = []
    this.setActiveStep(0)
  }

  *addNewProspects() {
    try {
      yield this.cadenceService.addNewProspects(this.cadence?.cadenceId, this.selectedLeadList)
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Added Extra Prospects Successfully',
      });
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }

  }

  setSelectedProspectId(prospectId) {
    this.selectedProspectId = prospectId
  }

  *pauseCadence(selectedCadence, reason: string) {
    try {
      this.cadenceService.pauseCadence(selectedCadence.cadenceId, reason);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Cadence Paused Successfully',
      });
      this.fetchCadenceTemplates();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }

  }

  *resumeCadence(selectedCadence) {
    try {
      this.cadenceService.resumeCadence(selectedCadence.cadenceId);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Cadence Resumed Successfully',
      });
      this.fetchCadenceTemplates();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  *getCadenceOptions(listType) {
    try {
      const response = yield this.cadenceService.cadenceOptions(listType);
      this.cadenceOptions = response?.data?.data?.map(cadence => ({
        label: cadence.cadenceName,
        value: cadence.cadenceId,
      }))
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  setCadenceOption(cadenceId) {
    this.currentCadenceId = cadenceId;
  }

  *addCadenceContacts(idList, listType, businessUnit) {
    try {
      yield this.cadenceService.addProspectsToCadence(idList, listType, businessUnit, this.currentCadenceId);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'This will be processed in a few minutes.',
      });
      this.addCadenceContactsSuccessfuly = true;
      this.fetchCadenceTemplates();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  setSelectedOriginator(value) {
    this.selectedOriginator = value;
  }

  *getOwners(cadenceId) {
    try {
      if (!cadenceId) return;
      const response = yield this.cadenceService.getOwners(cadenceId);
      const data = response.data.data || [];

      this.owners = [
        { label: "All", value: -1 },
        ...data.map((record) => ({
          label: record.originatorName,
          value: record.userId,
        })),
      ];
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  }

  resetOwners() {
    this.selectedOriginator = -1;
    this.owners = [];
  }

  *deleteCadence(cadenceId) {
    try {
      if (!cadenceId) return;
      const response = yield this.cadenceService.deleteCadence(cadenceId);
      this.globalStore.notificationStore.showSuccessNotification({ message: "Cadence have been deleted successfully." })
      this.cadenceTemplatesGridStore.resetAndFetchGridData();
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({ message: "Error while deleting cadence" })
      console.error("Error while deleting cadence", error);
    }
  }
}
